import { render } from "./Typeform.vue?vue&type=template&id=50b275a4&scoped=true"
import script from "./Typeform.vue?vue&type=script&lang=js"
export * from "./Typeform.vue?vue&type=script&lang=js"

import "./Typeform.vue?vue&type=style&index=0&id=50b275a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b275a4"]])

export default __exports__